import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_SECURITIES = gql`
  query fetchFinancialProducts($input: FetchFinancialProductsInput!) {
    fetchFinancialProducts(input: $input) {
      financialProducts {
        id
        ticker
        cusip
        isin
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        primaryAssetClass {
          id
          name
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        secondaryAssetClass {
          id
          name
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
      }
    }
  }
`;
